import EditableChip from './EditableChip';

export default EditableChip;
